module.exports = __webpack_public_path__ + "3e845b35408c178045746a00eb7a2c3e.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/grapplin-klaw.mp4
// module id = 634
// module chunks = 0